import styled from 'styled-components'

export const Container = styled.div`
  display: grid;

  ${props => props.theme.mediaQuery.up('tablet-landscape')} {
    grid-template-columns: minmax(655px, 1006px) minmax(200px, 330px);
    grid-column-gap: 24px;
  }
`

export const TrustBannerWrapper = styled.div`
  margin: 8px 0px 15px 0px
`
